'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024111 from "./presto.-Presto-Router$$anon$111.js";
import * as $j_presto$002e$002dUnknown$002dPage$0024 from "./presto.-Unknown-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$110() {
  this.bdr = null;
  this.bdj = null;
  this.bdk = false;
  this.bds = null;
  this.bdt = false;
  this.bdw = null;
  this.bdp = null;
  this.bdq = false;
  this.bdl = null;
  this.bdm = false;
  this.bdn = null;
  this.bdo = false;
  this.bdu = false;
  this.bdv = false;
  this.bdr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bdw = "UnknownPage";
}
export { $c_Lpresto_PrestoRouter$$anon$110 as $c_Lpresto_PrestoRouter$$anon$110 };
$p = $c_Lpresto_PrestoRouter$$anon$110.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$110;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$110() {
}
export { $h_Lpresto_PrestoRouter$$anon$110 as $h_Lpresto_PrestoRouter$$anon$110 };
$h_Lpresto_PrestoRouter$$anon$110.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bdr;
});
$p.M = (function() {
  if ((!this.bdk)) {
    this.bdj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bdk = true;
  }
  return this.bdj;
});
$p.O = (function() {
  if ((!this.bdt)) {
    this.bds = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bdt = true;
  }
  return this.bds;
});
$p.E = (function() {
  return this.bdw;
});
$p.t = (function() {
  if ((!this.bdq)) {
    this.bdp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("str", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bdq = true;
  }
  return this.bdp;
});
$p.N = (function() {
  if ((!this.bdm)) {
    this.bdl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bdm = true;
  }
  return this.bdl;
});
$p.Q = (function() {
  if ((!this.bdo)) {
    this.bdn = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024111.$c_Lpresto_PrestoRouter$$anon$111();
    this.bdo = true;
  }
  return this.bdn;
});
$p.v = (function() {
  if ((!this.bdv)) {
    this.bdu = false;
    this.bdv = true;
  }
  return this.bdu;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee658) => ((p) => \u03b4scrutinee658.cFE(p)))($j_presto$002e$002dUnknown$002dPage$0024.$m_Lpresto_UnknownPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$110 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$110, "presto.PrestoRouter$$anon$110", ({
  NI: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$110 as $d_Lpresto_PrestoRouter$$anon$110 };
//# sourceMappingURL=presto.-Presto-Router$$anon$110.js.map
